import React from 'react';
import styled from '@emotion/styled';
import SimpleButton from '../../../../common/button/SimpleButton';
import OtherBankTable from '../table/OtherBankTable';
import { LIGHT_BLUE } from '../../../../../styles/constants/color';
import useSwitching from '../../../../../hooks/common/useSwitching';
import CashbackModal from '../modal/CashbackModal';

const Base = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
  justify-content: end;
  align-items: center;
  width: 100%;
  height: auto;
`;

interface Props {
  closeEvent: () => void;
}

/**
 *  타금융사 할부비교 할부목록 컨텐츠 컴포넌트
 * @param {function} closeEvent 모달 닫기 이벤트 함수
 *  */
function OtherBankListContents({ closeEvent }: Props): JSX.Element {
  // state
  // 일시불 캐시백 모달 활성화 여부
  const [cashbackModal, switchingModal] = useSwitching(false);
  // CM 펼치기 여부
  const [openCm, switchingCm] = useSwitching(false);
  return (
    <>
      <Base>
        <ButtonWrapper>
          <SimpleButton
            text='일시불 캐시백'
            color={LIGHT_BLUE}
            borderColor={LIGHT_BLUE}
            onClick={switchingModal}
          />
          <SimpleButton
            text={`CM ${openCm ? '접기' : '펼치기'}`}
            onClick={switchingCm}
            color={LIGHT_BLUE}
            borderColor={LIGHT_BLUE}
          />
        </ButtonWrapper>
        <OtherBankTable openCm={openCm} closeEvent={closeEvent} />
      </Base>
      {cashbackModal && <CashbackModal closeEvent={switchingModal} />}
    </>
  );
}

export default OtherBankListContents;
